// Named, dated blocks stay independent of working periods, so moving one does
// not leave a second gap behind in the service schedule.
export function withNativeBlocks(info, blocks, iso, toMinutes) {
    const native = (blocks || []).filter(b =>
        String(b.startDate) < `${iso} 23:59:59` && String(b.endDate) > `${iso} 00:00:00`
    ).map(b => ({
        start: String(b.startDate).slice(0,10) < iso ? 0 : toMinutes(String(b.startDate).slice(11, 16)),
        end: String(b.endDate).slice(0,10) > iso ? 1440 : toMinutes(String(b.endDate).slice(11, 16)),
        kind: "native",
        nativeBlockId: b.id,
        title: b.name || "Blocked time",
        wholeDay: String(b.startDate).slice(11,16) === '00:00' && String(b.endDate).slice(11,16) === '00:00' && String(b.endDate).slice(0,10) > String(b.startDate).slice(0,10),
    })).filter(b => b.end > b.start);
    let periods = [...(info.periods || [])];
    for (const block of native) {
        periods = periods.flatMap(p => [
            {...p, end: Math.min(p.end, block.start)},
            {...p, start: Math.max(p.start, block.end)},
        ].filter(p => p.end > p.start));
    }
    // A named block takes visual precedence over an ordinary lunch underneath it.
    const breaks = (info.breaks || []).filter(b => !native.some(n => n.start <= b.start && n.end >= b.end));
    return {...info, periods, breaks: [...breaks, ...native].sort((a, b) => a.start - b.start)};
}
